export const REDUCER_NAME = "advertisement";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_ADVERTISEMENT = `${REDUCER_NAME}/SET_ADVERTISEMENT`;

export const getKey = (data) =>
  `${data.uid}_${data.type}_${data.competitionId}`;
